import axios from 'axios';
import configObject from '../temp/config';

// axios.defaults.headers.common['sc_apikey'] = '{0BF7C067-4B3F-4AEB-A2CD-61F0A58276B9}'

export default axios.create({
  baseURL: configObject.sitecoreApiHost,
});